import { render, staticRenderFns } from "./property.vue?vue&type=template&id=c6318c3c&"
import script from "./property.vue?vue&type=script&lang=js&"
export * from "./property.vue?vue&type=script&lang=js&"
import style0 from "./property.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('c6318c3c', component.options)
    } else {
      api.reload('c6318c3c', component.options)
    }
    module.hot.accept("./property.vue?vue&type=template&id=c6318c3c&", function () {
      api.rerender('c6318c3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/popup/property.vue"
export default component.exports